import { useContext, useState } from 'react';
import ChallengePlanningBar from './ChallengePlanningBar';
import ChallengeName from './ChallengeName';
import ChallengePreviewCard from './ChallengePreviewCard';
import ChallengeView from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView';
import ChallengePortfolioContext from '@/components/ChallengePortfolio/ChallengePortfolioContext';

type ChallengeProps = {
  challengeId: number;
};

const Challenge = ({ challengeId }: ChallengeProps) => {
  const [challengePortfolio] = useContext(ChallengePortfolioContext);
  const challenge = challengePortfolio.challenges[challengeId];

  const [challengeOpen, setChallengeOpen] = useState(false);

  if (!challenge.plannedStartDate || !challenge.plannedEndDate) {
    return null;
  }

  return (
    <>
      <ChallengePlanningBar
        challenge={challenge}
        onClick={() => setChallengeOpen(true)}
      >
        {(contentVisibilityCompensationDistance, contentMaxVisibleWidth) => (
          <>
            <ChallengeName
              contentVisibilityCompensationDistance={
                contentVisibilityCompensationDistance
              }
              contentMaxVisibleWidth={contentMaxVisibleWidth}
            >
              {challenge.name}
            </ChallengeName>
            <ChallengePreviewCard
              challenge={challenge}
              contentVisibilityCompensationDistance={
                contentVisibilityCompensationDistance
              }
            />
          </>
        )}
      </ChallengePlanningBar>
      {challengeOpen && (
        <ChallengeView
          challenge={challenge}
          onClose={() => setChallengeOpen(false)}
        />
      )}
    </>
  );
};

export default Challenge;
